import * as React from 'react';
import { BaseSvg, SVGIconProps } from './BaseSvg';

export const CheckCircle: React.SFC<SVGIconProps> = ({
  size = 24,
  color = '#2E2E3B',
  checkColor = '#e50f7e',
  ...props
}) => (
  <BaseSvg data-test-check-circle width={size} height={size} viewBox="0 2 24 24" {...props}>
    <g clipPath="url(#clip0_81_367)">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L6 13L7.41 11.59L10 14.17L13.795 10.375L16.59 7.58L18 9L10 17Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_81_367">
        <rect width="24" height="24" fill={checkColor} />
      </clipPath>
    </defs>
  </BaseSvg>
);
